import axios from 'axios';

import {ComplianceAuditFilters, ComplianceAuditMessages, ComplianceStatistic} from 'types';

import {API_URL} from './constants';

const complianceAuditUrl = `${API_URL}/compliance-audit`;

const getStatistic = async (filters: ComplianceAuditFilters): Promise<ComplianceStatistic> => {
    const response = await axios.get(`${complianceAuditUrl}/statistic`, {params: filters});
    return response.data;
};

const getMessages = async (
    filters: ComplianceAuditFilters,
    {skip, limit}: {skip: number, limit: number}
): Promise<ComplianceAuditMessages> => {
    const response = await axios.get(`${complianceAuditUrl}/messages`, {params: {...filters, skip, limit}});
    return response.data;
};

export const complianceAuditApi = {
    getStatistic,
    getMessages
};
